import { render, staticRenderFns } from "./ModalVisualizarExcecoes.vue?vue&type=template&id=3fdc3d0b&lang=pug"
import script from "./ModalVisualizarExcecoes.vue?vue&type=script&lang=js"
export * from "./ModalVisualizarExcecoes.vue?vue&type=script&lang=js"
import style0 from "./ModalVisualizarExcecoes.vue?vue&type=style&index=0&id=3fdc3d0b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports